import { useIssueView } from '../model/use-issue-view';
import { IssueReaderShell } from './issue-reader-shell';

export const Issue = ({ onClickLogOut }: IssueViewProps) => {
	const view = useIssueView({ onClickLogOut });
	return <IssueReaderShell view={view} />;
};

export interface IssueViewProps {
	onClickLogOut?: (url?: string) => void;
}

export default Issue;
